import { http } from '@/utils/http'
import envUtils from '@/utils/envUtils'

export const BPBASE = envUtils('VUE_APP_BP_SERVICE')

/**
 * 获取所有操作模块信息集合的方法
 */
export function getAllOpModule() {
  return http.get(`${BPBASE}/system/op_module/getAll`)
}

/**
 * 根据tenantId获取该租户套餐内可访问的所有【应用】
 */
export function getAccessApp() {
  return http.get(`${BPBASE}/data/tenant/getAccessApp`)
}
